<template>
<div v-if="articles" class="article-list">
    <div class="row my-3">
        <div v-for="(article, index) in articles3columns" :key="index" class="col-md-4 my-3">
            <ArticleComponent :article="article" type="article-3"/>
        </div>
    </div>
    <div class="row mb-3">
        <div v-for="(article, index) in articles2columns" :key="index" class="col-md-6 mb-3">
            <ArticleComponent :article="article" type="article-2"/>
        </div>
    </div>
    <div v-if="articles.length > 5" class="row mb-3">
        <ArticleComponent :article="article1column" class="col-12 mb-3" type="article-1" />
    </div>
</div>
</template>
<script>
import ArticleComponent from './ArticleComponent.vue'
export default {
  name: 'ClusteredArticles',
  components: {
    ArticleComponent
  },
  props: {
    articles: Array
  },
  computed: {
    articles3columns () {
      return this.articles.slice(0, 3)
    },
    articles2columns () {
      if (this.articles.length > 3) {
        return this.articles.slice(3, 5)
      }
      return []
    },
    article1column () {
      if (this.articles.length > 5) {
        return this.articles[this.articles.length - 1]
      }
      return []
    }
  }
}
</script>
<style lang="scss" >
  .article-list{
    .article{
      max-height: 350px;
    }
    img{
        max-height: 350px;
    }
  }
</style>
